import React from 'react';
import { SystemAdminPage } from '../SystemAdminPage';

export const NewsroomManagerPage: React.FC = () => {
  return <SystemAdminPage initialTab="newsroom" />;
};
